import React from "react";
import TableIncidents from "./TableIncidents.tsx";

const TableIncidentsDirectBoss = () => {
  return <TableIncidents forceDirectBoss />;
};

export default TableIncidentsDirectBoss;

